export const timeDiffInSeconds = (start: number, end: number) =>
  (end - start) / 1000;
